import axios from "axios";

export default {
  getSmsList(
    { commit },
    {
      perPage,
      page,
      user_name,
      company_uuid,
      user_email,
      recipient_uuid,
      text,
      ani,
      dnis,
      smsc_id,
      sms_uuid,
      sent_to,
      is_received,
      order_by,
      order_dir,
    }
  ) {
    console.log(order_by, "888");
    console.log(order_dir, "9999");
    return axios({
      url: "/sms/list?",
      params: {
        order_by: order_by ? order_by : "created_on",
        order_dir: order_dir ? order_dir : "desc",
        per_page: perPage || 10,
        page: page || 0,
        company_uuid: company_uuid=='All' ? '' : company_uuid,
        user_name: user_name=='All' ? '' : user_name,
        sms_uuid: sms_uuid || "",
        dnis: sent_to || "",
        is_received: is_received=='All' ? '' : is_received,
        user_email: user_email || "",
        recipient_uuid: recipient_uuid || "",
        text: text ? "*" + text + "*" : "",
        ani: ani ? "*" + ani + "*" : "",
        recipient_number: dnis ? "*" + dnis + "*" : "",
      },
      method: "GET",
    }).then((res) => {
      const { items: smses, total, per_page } = res.data.payload;
      commit("SET_ALL_SMS_LIST", { smses, total, per_page });
      commit("SET_LAST_SMS", smses[0]);
      return res.data.payload;
    });
  },
  getSmsListLog({ commit }, query) {
    return axios({
      url: "/sms/list?order_by=created_on&order_dir=desc",
      params: query,
      method: "GET",
    }).then((res) => {
      const { items: smses, total, per_page } = res.data.payload;
      commit("SET_ALL_SMS_LIST", { smses, total, per_page });
      commit("SET_LAST_SMS", smses[0]);
      return res.data.payload;
    });
  },
  getSmsReport({ commit }, alert) {
    commit("setLoading", true);
    return axios({
      url: "/sms/report",
      method: "GET",
      params: {
        group_by_company: true,
        page: alert.page || 0,
        company_name: alert.company_name
          ? "*" + alert.company_name + "*"
          : null,
        per_page: alert.per_page || 10,
        date_gte: alert.date_gte,
        date_lte: alert.date_lte,
      },
    }).then((res) => {
      const { items: smsReport, total, per_page } = res.data.payload;
      commit("SET_SMS_REPORT", { smsReport, total, per_page });
      commit("setLoading", false);
      return res.data.payload;
    });
  },
  getSmsResellerReport({ commit }, list) {
    return axios({
      url:
        "/sms/reseller/report?per_page=" +
        list.per_page +
        "&company_name=*" +
        list.company_name +
        "*" +
        "&group_by_company=true" +
        "&date_gte=" +
        list.year +
        "-" +
        list.month +
        "-01&date_lte=" +
        list.year +
        "-" +
        list.month +
        "-" +
        list.last_day,
      method: "GET",
    }).then((res) => {
      const { items: smsResellerReport, total, per_page } = res.data.payload;
      commit("SET_SMS_RESELLER_REPORT", { smsResellerReport, total, per_page });
      return res.data.payload;
    });
  },
  getSmsRecipientReport({ commit }, perPage) {
    return axios({
      url: "/sms/recipient/report?order_by=created_on&order_dir=desc",
      params: {
        per_page: perPage || 10,
      },
      method: "GET",
    }).then((res) => {
      const { items: smsRecipientReport, total, per_page } = res.data.payload;
      commit("SET_SMS_RECIPIENT_REPORT", {
        smsRecipientReport,
        total,
        per_page,
      });
      return res.data.payload;
    });
  },
  postSms({ commit }, sms) {
    return axios({
      url: "/sms",
      data: sms,
      method: "POST",
    }).then((res) => {
      commit("SET_LAST_SMS", res);
      return res;
    });
  },
  EditSms({ commit }, sms) {
    return axios({
      url: "/sms/" + sms.id,
      data: sms.sms,
      method: "PATCH",
    })
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return err;
      });
  },
  updateSmsReport({ commit }) {},
  updateActiveRecipient({ commit }, recipient) {
    commit("UPATE_ACTIVE_RECIPIENT", recipient);
  },
  updateUreadCount({ commit }, i) {
    commit("UPDATE_UNREAT_COUNT", i);
  },
  updateSmsRecipientReport({ commit }, smsRecipientReport) {
    commit("UPDTE_SMS_RECIPIENT_REPORT", smsRecipientReport);
  },
  resetSmsState({ commit }) {
    commit("RESET_STATE");
  },
};
